import { IIdItem } from './resourceParts';

export interface IUserName extends IIdItem {
  displayName: string;
  username: string;
  domainName?: string;
}

export interface IUser extends IUserName {
  authId?: string; // TODO: confirm that the server still uses this field
  readOnly?: boolean;
  isHiddenInternalUser?: boolean;
}

export interface IUserWithPublicInfo extends IUser {
  ownedItemCounts?: ItemCounts;
}

export interface ItemCounts {
  workbookCount: number;
  viewCount: number;
  datasourceCount: number;
}

export let UserKeys = {
  id: 'id',
  authId: 'authId',
  displayName: 'displayName'
};
